import Api from '@/vuex/api'
import {
  CLOSE_REPORT,
  OPEN_MODAL,
  SEND_REPORT,
  LOAD_REPORTS,
  CURRENT_REPORT_SEARCH,
  GET_IN_USE_REPORTS,
  IN_USE_REPORTS
} from '@/vuex/types'

const api = new Api()

const state = {
  reports: {
    dates: [],
    permalink: false,
    rows: [],
    noReslts: 'no Result default text',
    offset: 0,
    limit: 10,
    searchForm: {
      fields: []
    }
  },
  inUseReports: [],
  currentReportSearch: {}
}

const getters = {
  /**
   * @description Get all the report in edit mode
   * @param {JSON object} {inUseReports}
   * @returns returns the value of reports in edit form.
   */
  inUseReports ({ inUseReports }) {
    return inUseReports
  },

  /**
   * @description Take the value of current loaded reports from the state variables and facilitates that value to the vue-component that will specify the getter as loaded reports.
   * @param {JSON object} {reports}
   * @returns returns the value of current loaded reports that customer is viewing on the html page.
   */
  loadedReports ({reports}) {
    return reports
  },

  /**
   * @description Add limit field in the search form (which could have different fields that is specified in server report controller)
   * @param {JSON object} {reports}
   * @returns Array of fields that will display in search form.
   */
  reportsSearchForm ({reports}) {
    return reports.searchForm.fields.concat([{
      name: 'limit',
      label: 'Limit per page',
      type: 'search',
      value: reports.limit
    }])
  }
}

const mutations = {
  [IN_USE_REPORTS] (context, reports) {
    context.inUseReports = reports
  },
  [LOAD_REPORTS] (context, reports) {
    context.reports = reports
  },
  [CURRENT_REPORT_SEARCH] (context, options) {
    context.currentReportSearch = options
  }
}

const actions = {
  async [GET_IN_USE_REPORTS] (context) {
    let data = await api.getInUseReports()
    context.commit(IN_USE_REPORTS, data)
  },
  async [CLOSE_REPORT] (context, openReportUuid) {
    let data = await api.closeReport(openReportUuid)
    context.commit(IN_USE_REPORTS, data)
  },
  [SEND_REPORT] (context, QuoteUuid) {
    let sendModal = {
      permalink: 'sendReport',
      options: {
        title: 'Send Report',
        actionLabel: 'Send Report'
      },
      params: {
        QuoteUuid
      }
    }
    context.dispatch(OPEN_MODAL, sendModal)
  },
  async [LOAD_REPORTS] (context, options) {
    if (!options) {
      options = context.state.currentReportSearch
    }
    let data = await api.getReports(options)
    context.commit(LOAD_REPORTS, data)
    context.commit(CURRENT_REPORT_SEARCH, options)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/reports.js